// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DealFromJSON, DealToJSON, } from './';
export function AssetFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'sector': !exists(json, 'sector') ? undefined : json['sector'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'website': !exists(json, 'website') ? undefined : json['website'],
        'deals': !exists(json, 'deals') ? undefined : json['deals'].map(DealFromJSON),
        'referenceDate': !exists(json, 'referenceDate') ? undefined : new Date(json['referenceDate']),
    };
}
export function AssetToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'name': value.name,
        'type': value.type,
        'sector': value.sector,
        'country': value.country,
        'currency': value.currency,
        'website': value.website,
        'deals': value.deals === undefined ? undefined : value.deals.map(DealToJSON),
        'referenceDate': value.referenceDate === undefined ? undefined : value.referenceDate.toISOString(),
    };
}
